module.exports = __webpack_public_path__ + "assets/img/Back_001.94c86c80-ps.jpg";